
export type GetPlansParams = {
/**
 * Product code to filter plans (e.g., EDUSENSE_PLATFORM)
 */
productCode?: string;
/**
 * Page number for pagination (0-based)
 */
page?: number;
/**
 * Number of items per page
 */
size?: number;
};
